// extracted by mini-css-extract-plugin
export default {"selfAssignButton":"AssigneesSection-module__selfAssignButton--U9FC1"};